import React, { useEffect, useContext } from 'react'
// @mui material components
import Card from '@mui/material/Card'
import Icon from '@mui/material/Icon'
import Grid from '@mui/material/Grid'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogTitle from '@mui/material/DialogTitle'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import * as XLSX from 'xlsx'

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDSnackbar from 'components/MDSnackbar'
import MDButton from 'components/MDButton'
import MDDropdown from 'components/MDDropdown'

// Material Dashboard 2 PRO React example components
import DashboardLayout from 'components/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'components/Navbars/DashboardNavbar'
import Footer from 'components/Footer'
import ZuDataTable from 'components/ZeroUno/ZuDataTable'

// zerouno
import deviceService from 'services/device.service'
import authService from 'services/auth.service'
import { Link } from 'react-router-dom'
import ZUTitleForm from 'components/ZeroUno/ZUTitleForm'
import RabbitContext from 'context/rabbit.js'
import ZULed from 'components/ZeroUno/ZULed'

export default function DeviceTable () {
  const [objId, setObjId] = React.useState(0)
  const [objects, setObjects] = React.useState([])
  const [showSnackbar, setShowSnackbar] = React.useState({
    sh: false,
    msg: '',
    color: 'success'
  })
  const [openConfirm, setOpenConfirm] = React.useState(false)
  const [openMenuActions, setOpenMenuActions] = React.useState(false)

  useEffect(() => {
    fetchObjects()
  }, [])

  const fetchObjects = () => {
    deviceService.findAll().then(
      response => {
        setObjects(response.data)
      },
      error => {
        setShowSnackbar({
          sh: true,
          msg: error.response
            ? error.response.data.message
            : 'errore di ricezione dati',
          color: 'error'
        })
      }
    )
  }

  // Delete
  const deleteObject = () => {
    setOpenConfirm(false)
    deviceService.remove(objId).then(
      response => {
        setShowSnackbar({
          sh: true,
          msg: 'operazione effettuata con successo',
          color: 'success'
        })
        fetchObjects()
      },
      error => {
        setShowSnackbar({
          sh: true,
          msg: error.response
            ? error.response.data.message
            : 'errore di ricezione dati',
          color: 'error'
        })
      }
    )
  }

  const columns = [
    {
      header: 'azioni',
      enableSorting: false,
      enableColumnFilter: false,
      width: 100,
      accessorKey: 'id',
      Cell: ({ cell }) => (
        <Grid container spacing={1}>
          <Grid item>
            <MDButton
              color='info'
              size='small'
              iconOnly
              component={Link}
              to={'/devices/' + cell.getValue()}
            >
              <Icon>edit</Icon>
            </MDButton>
          </Grid>
          <Grid item>
            <MDButton
              color='info'
              size='small'
              iconOnly
              component={Link}
              to={'/devices/' + cell.getValue() + '?clone'}
            >
              <Icon>content_copy</Icon>
            </MDButton>
          </Grid>
          <Grid item>
            <MDButton
              iconOnly
              color='error'
              size='small'
              onClick={() => {
                setObjId(cell.getValue())
                setOpenConfirm(true)
              }}
            >
              <Icon>delete</Icon>
            </MDButton>
          </Grid>
        </Grid>
      )
    },
    {
      header: 'Modello',
      accessorKey: 'model.name',
      width: 150
    },
    {
      header: 'Seriale',
      accessorKey: 'serial',
      width: 150
    },
    {
      header: 'Mac',
      accessorKey: 'macAddress',
      width: 150
    },
    {
      header: 'Cliente',
      accessorKey: 'deviceCustomers[0].registry.businessName',
      accessorFn: (row) => {
        const deviceCustomers = row.deviceCustomers
        if (deviceCustomers && deviceCustomers.length > 0) {
          return deviceCustomers[0].registry?.businessName || 'NON ASSEGNATO'
        }
        return 'NON ASSEGNATO'
      },
      width: 150,
      
    },
    {
      header: 'Attivo',
      enableSorting: false,
      enableColumnFilter: false,
      width: 100,
      accessorKey: 'active',
      Cell: ({ cell }) => <ZULed status={cell.getValue()} />
    },
    
  ]

  const exportExcel = () => {
    // Prepare data for export with the specified columns
    const exportData = objects.map(device => {
      const cliente = device.deviceCustomers && device.deviceCustomers.length > 0 
        ? device.deviceCustomers[0].registry?.businessName || ''
        : ''
      
      return {
        id: device.id || '',
        modello: device.model?.name || '',
        seriale: device.serial || '',
        macAddress: device.macAddress || '',
        numeroFattura: device.invoiceNumber || '',
        dataFattura: device.invoiceDate || '',
        fornitore: device.registry?.businessName || '',
        cliente: cliente,
        attivo: device.active ? 'Sì' : 'No',
        note: device.notes || ''
      }
    })

    // Create a new workbook
    const ws = XLSX.utils.json_to_sheet(exportData)
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Apparati')

    // Generate Excel file and download
    XLSX.writeFile(wb, `apparati_${new Date().toISOString().split('T')[0]}.xlsx`)
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Card>
          <ZUTitleForm bgColor='info' title='Apparati' icon='groups' />

          <MDBox
            p={3}
            lineHeight={1}
            display='flex'
            justifyContent='space-between'
          >
            <MDBox display='flex' gap={1}>
                <MDButton color='info' component={Link} to='/devices/new' m={1}>
                  nuovo
                </MDButton>
              <MDButton color='success' onClick={exportExcel} m={1}>
                <Icon>file_download</Icon>&nbsp; Esporta Excel
              </MDButton>
            </MDBox>
            {authService.isAdmin() && (
            <MDButton
              variant='gradient'
              color='light'
              component={Link}
              to='/device-models'
            >
              <Icon>router</Icon>&nbsp; Modelli
            </MDButton>
              )}
            </MDBox>
          <ZuDataTable table={{ columns: columns, rows: objects }} />
        </Card>
      </MDBox>
      <Footer />
      <Dialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          Confermi eliminazione?
        </DialogTitle>
        <DialogActions>
          <MDButton onClick={() => setOpenConfirm(false)}>Annulla</MDButton>
          <MDButton onClick={deleteObject} autoFocus>
            Conferma
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDSnackbar
        color={showSnackbar.color}
        icon='notifications'
        title='Notifica'
        content={showSnackbar.msg}
        dateTime='adesso'
        open={showSnackbar.sh}
        autoHideDuration={5000}
        close={() => setShowSnackbar({ sh: false, msg: '', color: 'info' })}
      />
    </DashboardLayout>
  )
}
